export default __webpack_public_path__ + "static/media/BrixSansExtralight.22c67cba.woff";